var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71039 4.29722L13.8177 2.81641L12.5465 7.97984L10.9606 6.45746L8.4026 9.12208C8.31576 9.21254 8.19578 9.26367 8.07039 9.26367C7.94499 9.26367 7.82502 9.21254 7.73817 9.12208L5.8599 7.16554L3.09742 10.0431C2.92128 10.2266 2.62976 10.2325 2.44628 10.0564C2.26281 9.88027 2.25686 9.58875 2.43299 9.40527L5.52768 6.18164C5.61452 6.09118 5.7345 6.04004 5.8599 6.04004C5.98529 6.04004 6.10527 6.09118 6.19211 6.18164L8.07039 8.13818L10.2962 5.81961L8.71039 4.29722Z",
    fill: "#21FF11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRise);
export default __webpack_public_path__ + "static/media/ArrowRise.2a51ba363922bca135f735a83583d210.svg";
export { ForwardRef as ReactComponent };